// extracted by mini-css-extract-plugin
export var active = "_1p-9";
export var backButton = "_1p-8";
export var clone = "_1p-e";
export var collapseBar = "_1p-k";
export var collapseMode = "_1p-m";
export var collapsed = "_1p-o";
export var dimmed = "_1p-i";
export var dragHandle = "_1p-c";
export var dropdownIcon = "_1p-g";
export var expanding = "_1p-n";
export var hidden = "_1p-x";
export var iconContainer = "_1p-q";
export var iconSwapper = "_1p-w";
export var navItem = "_1p-6";
export var navItemIcon = "_1p-f";
export var navProfile = "_1p-7";
export var notificationCountBadge = "_1p-j";
export var notificationDot = "_1p-r";
export var optionsContainer = "_1p-h";
export var primaryNav = "_1p-0";
export var primaryNavDivider = "_1p-v";
export var primaryNavResizeHandle = "_1p-2";
export var primaryNavResizing = "_1p-1";
export var primaryNavTabSection = "_1p-u";
export var primaryTab = "_1p-p";
export var primaryTabIconBox = "_1p-s";
export var secondaryNav = "_1p-3";
export var selected = "_1p-t";
export var settingsNav = "_1p-4";
export var settingsNavItems = "_1p-5";
export var show = "_1p-d";
export var sideNav = "_1p-l";
export var teamItem = "_1p-a";
export var userProfileItem = "_1p-b";